var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGroupAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 5,
    r: 1.5,
    fill: "#002A69"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6,
    r: 2,
    fill: "#002A69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7C11.8304 7 12.6267 7.3163 13.2139 7.87891C13.552 8.20297 13.8054 8.59357 13.959 9.01855C14.1473 9.54032 13.6632 10 13.0869 10H12.8818C12.8818 9.17166 12.2101 8.50014 11.3818 8.5C10.6475 8.5 10.0366 9.02773 9.90723 9.72461C9.82312 9.62995 9.73577 9.53758 9.64355 9.44922C9.24072 9.06327 8.77929 8.75001 8.28125 8.51367C8.41829 8.28351 8.58717 8.06957 8.78613 7.87891C9.37329 7.3163 10.1696 7 11 7Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50105 9C7.57729 9.00012 8.61491 9.3944 9.44539 10.1064C8.89149 10.327 8.50007 10.8675 8.50007 11.5C8.50007 12.3284 9.17165 13 10.0001 13C10.0001 13.3167 10.0981 13.6104 10.2657 13.8525C10.0741 13.9457 9.85819 13.9999 9.63191 14H3.36922C2.50495 13.9997 1.77998 13.2338 2.06257 12.3643C2.29295 11.656 2.67252 11.0049 3.17976 10.4648C4.06049 9.52716 5.25551 9 6.50105 9Z",
    fill: "#002A69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5H13M11.5 10V13",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGroupAvatar);
export default __webpack_public_path__ + "static/media/Add_group_avatar.bfcddd8af18f11fca4dfb954975b6181.svg";
export { ForwardRef as ReactComponent };